export default __webpack_public_path__ + "static/media/PWT_box_full_logo.0af3038e.png";